import BaseService from "./BaseService";
import { unwrapResponse } from "./unwrapResponse";
export default class BugReportService extends BaseService {
    static async create(formData) {
        const res = await this.post(`/bug-reports`, formData);
        return unwrapResponse(res);
    }
    static async adminList(params = {}) {
        const res = await this.get(`/bug-reports`, params, "ADMIN");
        return unwrapResponse(res);
    }
}
